if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();

        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) return;

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() { return true; }
      get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
      get delay() { return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 25; }
      get expiry() { return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30; }
      get cookieName() { return 'concept:newsletter-popup'; }
      get submited() { return this.querySelector('.alert') !== null; }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.submited) {
          this.load(1);
          return;
        }

        if (!this.testMode && this.getCookie(this.cookieName)) return;
        if (Shopify.designMode) return;

        const desktop = window.matchMedia('(pointer: fine)').matches && !theme.config.isTouch;

        if (desktop) {
          let armed = false;
          setTimeout(() => { armed = true; }, 5000);

          const onExit = (event) => {
            if (!armed) return;
            if (event.clientY <= 8 && !event.relatedTarget) {
              document.removeEventListener('mouseout', onExit);
              this.show();
            }
          };
          document.addEventListener('mouseout', onExit);
        } else {
          let shown = false;
          const showOnce = () => {
            if (shown) return;
            shown = true;
            window.removeEventListener('scroll', onScroll);
            this.show();
          };
          const onScroll = () => {
            const pageHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            const progress = (window.scrollY + window.innerHeight) / pageHeight;
            if (progress >= 0.55) showOnce();
          };

          window.addEventListener('scroll', onScroll, { passive: true });
          setTimeout(showOnce, Math.max(this.delay, 25) * 1000);
        }
      }

      load(delay) {
        if (Shopify.designMode) return;
        setTimeout(() => this.show(), delay * 1000);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}
